// en translations
export const EN_TRANSLATIONS: { [key: string]: string } = {


    "--DropoffLateReason": "-- Dropoff Late Reason --",
    "--FundingSource--": "-- Funding Source --",
    "--PickupLateReason": "-- Pickup Late Reason --",
    "--Seats--": "-- Seats --",
    "--Select--": "-- Select --",
    "--SelectAccountStatus": "-- Select Account Status --",
    "--SelectAssist--": "-- Select Assist --",
    "--SelectBodyType": "-- Select Body Type --",
    "--SelectBroker--": "-- Select Broker --",
    "--SelectCancelReasons": "-- Select Cancel Reasons --",
    "--SelectCapacity--": "-- Select Capacity --",
    "--SelectCompetency--": "-- Select Competency --",
    "--SelectCorporateUser": "-- Select Corporate User --",
    "--SelectDateFormat": "-- Select Date Format --",
    "--SelectDay--": "-- Select Day --",
    "--SelectDiagnosismedicalCond": "-- Select Diagnosis/Medical Condition --",
    "--SelectDoModifier": "-- Select DO Modifier --",
    "--SelectDrivers--": "-- Select Drivers --",
    "--SelectDrivers--2": "-- Select drivers  --",
    "--SelectEmploymentType": "-- Select Employment Type --",
    "--SelectEquipment--": "-- Select Equipment --",
    "--SelectFleet--": "-- Select Fleet --",
    "--SelectFs--": "-- Select FS --",
    "--SelectFuelType": "-- Select Fuel Type --",
    "--SelectGroup--": "-- Select Group --",
    "--SelectMapper--": "-- Select Mapper --",
    "--SelectMemberRole": "-- Select Member Role --",
    "--SelectMethod--": "-- Select Method --",
    "--SelectMonth--": "-- Select Month --",
    "--SelectOperationsManager": "-- Select Operations Manager --",
    "--SelectPlatformportal--": "-- Select Platform/Portal --",
    "--SelectPosition--": "-- Select Position --",
    "--SelectProficiency--": "-- Select Proficiency --",
    "--SelectPuModifier": "-- Select PU Modifier --",
    "--SelectReason--": "-- Select Reason --",
    "--SelectRoleType": "-- Select Role Type --",
    "--SelectServiceAreas": "-- Select Service Area(s) --",
    "--SelectShiftAlign": "-- Select Shift Align --",
    "--SelectSpacetype--": "-- Select SpaceType --",
    "--SelectStateCode": "-- Select State Code --",
    "--SelectStationManager": "-- Select Station Manager --",
    "--SelectStatus--": "-- Select Status --",
    "--SelectStatuss--": "-- Select Status(s) --",
    "--SelectTemplate--": "-- Select Template --",
    "--SelectTimeFormat": "-- Select Time Format --",
    "--SelectType--": "-- Select type --",
    "--SelectVehicle--": "-- Select Vehicle --",
    "--ServiceArea--": "-- Service Area --",
    "--SpaceType--": "-- Space Type --",
    "--selectRequiredOdometer--": "--Select Required Odometer--",
    "--selectStatus--": "--Select Status--",
    "-selectFundingSource-": "-Select Funding Source-",
    "10min": "10min",
    "15min": "15min",
    "1HourViolation": "1 Hour Violation",
    "30min": "30min",
    "Amendments": "Amendments",
    "Announcement": "Announcement",
    "Cities Zones": "Cities Zones",
    "Companies": "Companies",
    "Drivers": "Drivers",
    "Drivers Load": "Drivers Load",
    "Equipment Planning": "Equipment Planning",
    "Equipments": "Equipments",
    "Funding Sources": "Funding Sources",
    "Holidays": "Holidays",
    "Late Forecast": "Late Forecast",
    "Late Reasons": "Late Reasons",
    "Level of Service": "Level of Service",
    "Mapper": "Mapper",
    "Members": "Members",
    "Miles For Bucks": "Miles For Bucks",
    "New Trip": "New Trip",
    "Offered": "Offered",
    "Payors": "Payors",
    "Profiling": "Profiling",
    "Quarters": "Quarters",
    "Schedule": "Schedule",
    "Service Areas": "Service Areas",
    "Shift Override": "Shift Override",
    "Space Type Checklist": "Space Type Checklist",
    "Space Types": "Space Types",
    "Staff": "Staff",
    "Standing Orders": "Standing Orders",
    "Templates": "Templates",
    "Timesheet": "Timesheet",
    "Trip Sheet": "Trip Sheet",
    "Vehicles": "Vehicles",
    "Violations": "Violations",
    "aaccountStatusIsRequired": "Aaccount status is required",
    "accept": "Accept",
    "accepted": "Accepted",
    "acceptedTrips": "Accepted Trips",
    "accidentAndIncidentTraining": "Accident and Incident Training",
    "accountStatus": "Account Status",
    "accountStatusIsRequired": "Account Status is required",
    "acknowledgeByDriver": "Acknowledge by driver",
    "act": "Act",
    "action": "ACTION",
    "actions": "Actions",
    "actualShift": "Actual Shift",
    "add": "+ Add",
    "addAddon": "Add Addon",
    "addAmendment": "Add Amendment",
    "addAnnouncement": "Add Announcement",
    "addAppointmentType": "Add Appointment Type",
    "addBeneficiary": "Add Beneficiary",
    "addBreak": "Add Break",
    "addBroker": "Add Broker",
    "addCancelReason": "Add Cancel Reason",
    "addChecklist": "Add Checklist",
    "addCity": "Add City",
    "addCompany": "Add Company",
    "addDistribution": "Add Distribution",
    "addDriver": "Add Driver",
    "addEquipment": "Add Equipment",
    "addFundingSource": "Add Funding Source",
    "addHoliday": "Add Holiday",
    "addLegButton": "+ Leg",
    "addLevelOfService": "Add Level of Service",
    "addMapper": "Add Mapper",
    "addMember": "Add Member",
    "addModifierCode": "Add Modifier Code",
    "addPayor": "Add Payor",
    "addPrimaryDiagnose": "Add Primary Diagnose",
    "addQuarter": "Add Quarter",
    "addRate": "Add Rate",
    "addReason": "Add Reason",
    "addServiceArea": "Add Service Area",
    "addShift": "Add Shift",
    "addShiftOverride": "Add Shift Override",
    "addSpaceType": "Add Space Type",
    "addStaff": "Add Staff",
    "addTemplate": "Add Template",
    "addTips": "Add Tips",
    "addTripHeader": "Add",
    "addVehicle": "Add Vehicle",
    "addYourComment": "Add your comment",
    "addYourComment2": "Add your comment...",
    "addZone": "Add Zone",
    "additionalInformation": "Additional Information",
    "additionalNote": "Additional Note",
    "addonButton": "+ Addon",
    "addonItemLabel": "Item",
    "addonItemRequired": "Item is required",
    "addonServicesHeader": "Addon Services",
    "address": "Address:",
    "addressLabel": "Address",
    "addressName": "Address Name",
    "addressNameIsRequired": "Address Name is required",
    "addressRequired": "Address is required",
    "addressValidationAlert": "Address Validation Alert",
    "addupdateSignature": "Add/Update Signature",
    "adjustTrip": "Adjust Trip",
    "adjustment": "Adjustment",
    "adlAmbulanceDriversLicense": "ADL (AMBULANCE DRIVERS LICENSE)",
    "adlImageIsRequired": "ADL Image is required",
    "admin": "Admin",
    "agent": "Agent",
    "alarming": "Alarming",
    "alarmingTrips": "Alarming Trips",
    "alcReminder": "ALC Reminder",
    "alcoholScreeningRecentScreen": "Alcohol Screening (Recent Screening)",
    "algorithm": "Algorithm",
    "all": "All",
    "allDrivers": "All Drivers",
    "allMessages": "All Messages",
    "allNotifications": "All Notifications",
    "allowAttendee": "Allow Attendee",
    "allowAuthorizationNumberFor": "Allow Authorization Number for One Care",
    "allowPlacement": "Allow Placement",
    "allowCamera": "Allow Camera",
    "allowCapacityViolation": "Allow Capacity Violation",
    "allowCapacityViolations": "Allow Capacity Violation(s)",
    "allowIncentive": "Allow Incentive",
    "allowIpcr": "Allow IPCR",
    "allowAuditLogs": "Allow Audit Logs",
    "allowCoverage": "Allow Coverage",
    "auditlogs": "Audit Logs",
    "allowMulti-factorAuthenticat": "Allow Multi-Factor Authentication",
    "allowNearBy": "Allow Near By",
    "allowOnboardViolations": "Allow Onboard Violation(s)",
    "allowPossibility": "Allow Possibility",
    "allowSms": "Allow Sms",
    "allowTimesheet": "Allow Timesheet",
    "allowVoiceAssistance": "Allow Voice Assistance",
    "ambulance": "Ambulance",
    "ambulette": "Ambulette",
    "amendment": "Amendment",
    "amountIsRequired": "Amount is required",
    "announcements": "Announcements",
    "api": "API",
    "appealed": "Appealed",
    "appky": "Appky",
    "applyIncentive": "Apply Incentive",
    "appointmentDirectionInside": "Inside Center",
    "appointmentDirectionLabel": "Appointment Direction",
    "appointmentDirectionOutside": "Outside Center",
    "appointmentTime": "Appointment Time",
    "appointmentTimeIsRequired": "Appointment Time is required",
    "appointmentTypeLabel": "Appointment Type",
    "appointmentTypeRequired": "Appointment Type is required",
    "appointmentTypefileIsRequire": "Appointment Type(File) is required",
    "appointmentTypetpIsRequired": "Appointment Type(TP) is required",
    "approachingAlert": "Approaching Alert",
    "approachingTrips": "Approaching Trips",
    "approve": "Approve",
    "approved": "Approved",
    "aptOrSuiteIs": "APT or Suite is required",
    "aptOrSuiteLabel": "APT/SUITE",
    "aptOrSuiteRequired": "APT/SUITE is required",
    "aptsuiteroom": "Apt/Suite/Room",
    "arabicLanguageLabel": "Arabic",
    "archive": "Archive",
    "archived": "Archived",
    "archivedTrips": "Archived trips",
    "areYouSureYou": "Are you sure you want to move this trip to a new time?",
    "areYouSureYou2": "Are you sure you want to cancel ?",
    "areYouSureYou3": "Are you sure you want to update odometer ?",
    "areYouSureYou4": "Are you sure you want to create trip from the parent standing order on this particular date?",
    "areYouSureYou5": "Are you sure you want to sweep all the trips data from the system. You will have to re-import the data again to assign any trips to driver as this is a permanent action?",
    "arn": "ARN",
    "arrears": "Arrears",
    "arrearsLabel": "Arrears Label",
    "arrived": "Arrived",
    "assign": "Assign",
    "assignTrip": "Assign Trip",
    "assignMultipleTrips": "Assign Multiple Trips",
    "assignVehicle": "Assign Vehicle",
    "assignedTrips": "Assigned trips",
    "assist": "Assist",
    "assistShiftAlign": "Assist Shift Align",
    "assistShiftAlignIs": "Assist Shift Align is required",
    "assistShiftDayWise": "Assist Shift (Day Wise)",
    "assistShiftEnd": "Assist Shift End",
    "assistShiftEndIs": "Assist Shift End is required",
    "assistShiftStart": "Assist Shift Start",
    "assistShiftStartIs": "Assist Shift Start is required",
    "assistsLabel": "Assists",
    "associateImage": "Associate Image",
    "atLeastOneAssist": "At least one assist shift is required",
    "atleastOneDayShift": "Atleast one day shift is required",
    "atleastOneDriverIs": "Atleast one driver is required",
    "attachPdfButton": "Attach PDF",
    "attchedPdf": "Attched Pdf",
    "authNumberLabel": "Authorization Number",
    "authorizationNumberIsRequire": "Authorization Number is Required",
    "authorizer": "Authorizer",
    "autoAssignWillCall": "Auto Assign Will Call",
    "autoGenerate": "Auto Generate",
    "autoRefresh": "Auto Refresh",
    "autoTimeStamp": "Auto Time Stamp",
    "autoTimestamp": "Auto Timestamp",
    "autoZoom": "Auto Zoom",
    "available": "Available",
    "avatar": "avatar",
    "backToLogin": "Back to Login",
    "background": "Background",
    "badPhonenumber": "Bad PhoneNumber",
    "banked": "Banked",
    "baseFare": "Base Fare",
    "baseFareCode": "Base Fare Code",
    "baseFareCodeIs": "Base Fare Code is Required",
    "baseFareFor": "Base Fare For",
    "baseFareForIs": "Base Fare For is required",
    "baseFareIsRequired": "Base Fare is required",
    "batch": "Batch",
    "bedBugProtocol": "Bed Bug Protocol",
    "bedLengthIsRequired": "Bed length is required",
    "beginAt": "Begin At:",
    "billTo": "Bill To *",
    "billerNote": "Biller Note",
    "billerNotes": "Biller Notes",
    "billing": "Billing",
    "bloodbornePathogenTrainingEx": "Bloodborne Pathogen Training (EXP)",
    "bloodbornePathogens": "Bloodborne Pathogens",
    "bodyType": "Body Type",
    "bodyTypeIsRequired": "Body Type is required",
    "both": "Both",
    "break": "Break",
    "breakCushion": "Break Cushion:",
    "breakFinished": "Break (Finished)",
    "breakScheduled": "Break (Scheduled)",
    "breaks": "Breaks",
    "broker-img": "broker-img",
    "brokerConfiguration": "Broker Configuration",
    "brokerId": "Broker ID",
    "brokerIsRequired": "Broker is Required",
    "bsr": "BSR",
    "bsr2": "BSR:",
    "bulkConfirmation": "Bulk Confirmation",
    "businessNumber": "Business Number",
    "businessNumberIsRequired": "Business Number is required",
    "businessReport": "Business Report",
    "businessReports": "Business Reports",
    "busy": "Busy",
    "bySavingTheInformation": "By saving the information in this form, you hereby attest, as an authorized representative of the organization, that the information accurately reflects transports completed by the same. You do hereby certify that this information is true, accurate and complete to the best of your knowledge and you understand that any falsification, omission or concealment of material fact may subject you and/or the organization to contractual, administrative, civial or criminal liability. You additionally understand that all documentation for these transports are to be maintained in accordance with record maintenance policies of respective insurance brokers and their affiliates.",
    "caTimesheet": "CA Timesheet",
    "calculateButton": "Calculate",
    "calculateLocalMiles": "Calculate Local Miles",
    "call": "Call",
    "callMemberToVerify": "Call Member To Verify Cancellation",
    "cancel": "Cancel",
    "cancelCharges": "Cancel Charges",
    "cancelChargesIsRequired": "Cancel charges is required",
    "cancelReason": "Cancel Reason",
    "cancelReasons": "Cancel Reasons",
    "cancelReasonsIsRequired": "Cancel Reasons is required",
    "cancelTrip": "Cancel trip",
    "canceled": "Canceled",
    "cancellationNotes": "Cancellation Notes",
    "cancelled": "Cancelled",
    "cancelledAt": "Cancelled At:",
    "cancelledFee": "Cancelled Fee *",
    "cancelledTripsSection": "Cancelled trips section",
    "capacities": "Capacities",
    "capacity": "Capacity",
    "capacityIsRequired": "Capacity is required",
    "careGiverInformation": "Care Giver Information",
    "caregiverDetailsAreRequired": "Caregiver details are required",
    "centeneAttestationIss": "Centene Attestation (ISS)",
    "certificateOfCompletionOnlok": "Certificate of Completion (ONLOK)",
    "certificationIsRequired": "Certification is required",
    "certifiedMechanicVerificatio": "CERTIFIED MECHANIC VERIFICATION",
    "cf": "CF:",
    "change": "Change",
    "changePassword": "Change Password",
    "checkin": "Checkin",
    "checklist": "Checklist",
    "checklistIsRequired": "Checklist is required",
    "checklistNameIsRequired": "Checklist name is required",
    "checkout": "Checkout",
    "chineseLanguageLabel": "Chinese",
    "city": "City",
    "cityIsRequired": "City is required",
    "citystate": "City/State",
    "claim": "Claim",
    "claim2": "+ Claim",
    "claimIsRequired": "Claim is required",
    "claims": "Claims",
    "clear": "Clear",
    "clearVehicle": "Clear Vehicle",
    "clientIdLabel": "Client ID / Member ID / MA# / AHCCCS#",
    "clientIdRequired": "Client ID / Member ID / MA# / AHCCCS# is required",
    "clone": "Clone",
    "close": "Close",
    "closePanel": "Close panel",
    "closeSidebar": "Close sidebar",
    "closer": "Closer",
    "cms1500": "CMS 1500",
    "code": "Code",
    "codeIsRequired": "Code is required",
    "color": "Color",
    "colorIsRequired": "Color is required",
    "comment": "Comment",
    "commentIsRequired": "Comment is required",
    "comments": "Comments",
    "companiesStats": "Companies Stats",
    "company-img": "company-img",
    "companyAlias": "Company Alias *",
    "companyBillingName": "Company Billing Name",
    "companyFaxNumber": "Company Fax Number",
    "companyImage": "Company Image",
    "companyImageIsRequired": "Company Image is Required",
    "companyInTake": "Company In Take (%)",
    "companyInTakeIs": "Company In Take is required",
    "companyMobileNumber": "Company Mobile Number",
    "companyMobileNumberIs": "Company Mobile Number is required",
    "companyName": "Company Name",
    "companyNameIsRequired": "Company Name is required",
    "companyNotes": "Company Notes",
    "companyPhoto": "Company photo",
    "competency": "Competency",
    "competencyIsRequired": "Competency is required",
    "completed": "Completed",
    "completedFee": "Completed Fee *",
    "completedTimeIsRequired": "Completed Time is required",
    "compliancePlanTrainingFraud": "Compliance Plan Training (Fraud, Waste, and Abuse) (Code of Conduct)",
    "configurations": "Configurations",
    "confirm": "Confirm",
    "confirmNewPassword": "Confirm New Password",
    "confirmPassword": "Confirm Password",
    "confirmPasswordDidtMatch": "Confirm Password did't match",
    "confirmPasswordIsRequired": "Confirm Password is required",
    "confirmationReport": "Confirmation Report",
    "confirmationText": "Confirmation Text",
    "confirmedLabel": "Confirmed",
    "contactNumber": "Contact Number",
    "contactNumberIsRequired": "Contact Number is required",
    "contractSent": "Contract Sent",
    "corporate": "Corporate",
    "corporateOdometerRequired": "Corporate Odometer Required",
    "corporatePrivatePay": "Corporate/Private Pay",
    "costCenter": "Cost Center",
    "costCenterIsRequired": "Cost Center is required",
    "coverImage": "Cover Image",
    "covid": "Covid",
    "covid-19Vaccine": "COVID-19 Vaccine",
    "covid-19VaccineDeclined": "COVID-19 Vaccine Declined",
    "cprFirstAidCertification": "CPR / First Aid Certification Start Date (EXP)",
    "cprFirstAidCertification2": "CPR / First Aid Certification Expiry Date (EXP)",
    "createBucket": "Create Bucket",
    "createButton": "Create",
    "createSchedule": "Create Schedule",
    "createTrip": "Create Trip",
    "createTripsManually": "Create trips manually",
    "created": "Created",
    "createdTimeIsRequired": "Created Time is required",
    "credentialInformation": "Credential Information",
    "credentialing": "Credentialing",
    "credentials": "Credentials",
    "criminalBackgroundCheck": "Criminal Background Check",
    "criminalRecordAlcoholOr": "Criminal Record (Alcohol or Drug abuse)",
    "ctc": "CTC",
    "ctcBot": "CTC BOT",
    "ctcInvoice": "CTC Invoice",
    "ctcMarketplace": "CTC Marketplace",
    "ctcTrips": "CTC Trips",
    "currentMeter": "Current Meter",
    "currentMileageIsRequired": "Current mileage is required",
    "currentPassword": "Current Password",
    "currentPasswordIsRequired": "Current Password is required",
    "custom": "Custom",
    "daily": "Daily",
    "dashboard": "Dashboard",
    "date": "Date",
    "dateFormat": "Date Format",
    "dateFormatIsRequired": "Date Format is required",
    "dateIsRequired": "Date is required",
    "dateOfInspection": "Date of Inspection",
    "dateOfInspectionIs": "Date of inspection is required",
    "dateOfService": "Date of Service",
    "dateRange": "Date Range *",
    "dayRequired": "Day is required",
    "days": "Days",
    "days2": "Day(s)",
    "daysIsRequired": "Day(s) is required",
    "ddmmyyyy": "DD/MM/YYYY",
    "deadMiles": "Dead Miles",
    "deadMilesRateIs": "Dead Miles Rate is required",
    "deadheadTimeToPickup": "Deadhead Time (to Pickup)",
    "decline": "Decline",
    "defensiveDrivingCourse": "Defensive Driving Course",
    "delete": "Delete",
    "deleteAll": "Delete All",
    "demo": "Demo",
    "description": "Description",
    "descriptionIsRequired": "Description is required",
    "detail": "Detail",
    "details": "Details",
    "diagnosismedicalCondition": "Diagnosis/Medical Condition",
    "diagnosismedicalConditionIsR": "Diagnosis/Medical Condition is required",
    "dimensions": "Dimensions",
    "discount": "Discount",
    "discountLabel": "Discount Label",
    "dispatchMonthDay": "Dispatch Month Day *",
    "dispatcher": "Dispatcher",
    "dispatcherNotesLabel": "Dispatcher Notes",
    "display": "Display",
    "displayMode": "Display Mode",
    "displayNameLabel": "Display Name",
    "displayNameRequired": "Display Name is required",
    "displaySection": "Display Section",
    "do": "DO",
    "doModifier": "DO Modifier",
    "doModifierIsRequired": "DO Modifier is required",
    "doa": "DOA",
    "dobLabel": "Date of Birth",
    "dobRequired": "Date of birth is required",
    "done": "Done",
    "dos": "DOS:",
    "dot": "DOT",
    "dotPhysicalExamAnnual": "DOT Physical Exam (annual or upon request)",
    "downBaseAddress": "Down Base Address",
    "download": "Download",
    "downloadCsv": "Download CSV",
    "downloadPdf": "Download PDF",
    "downloadPdfReport": "Download PDF Report",
    "downloadReport": "Download Report",
    "drawRoute": "Draw Route",
    "driveDistance": "Drive Distance",
    "driver": "Driver",
    "driver-score-chartsWorks": "driver-score-charts works!",
    "driver2": "(Driver)",
    "driverAddress": "Driver Address",
    "driverAddressIsRequired": "Driver Address is required",
    "driverAlerts": "Driver Alerts",
    "driverBreak": "Driver Break",
    "driverBreakdown": "Driver Breakdown",
    "driverImage": "Driver Image",
    "driverInTake": "Driver In Take (%)",
    "driverInTakeIs": "Driver In Take is required",
    "driverInformation": "Driver Information",
    "driverIsGettingLate": "Driver is getting late",
    "driverIsIdle": "Driver is Idle (No Trips)",
    "driverIsLate": "Driver is Late",
    "driverIsOverloaded": "Driver is Overloaded (>12 trips)",
    "driverLoad": "Driver Load",
    "driverName": "Driver Name",
    "driverNotesLabel": "Driver Notes",
    "driverOdometer": "Driver Odometer",
    "driverProfile": "Driver Profile",
    "driverRequired": "Driver is required",
    "driverRoadTrainingEvidence": "Driver Road Training (Evidence)",
    "driverSched": "Driver Sched",
    "driverShift": "Driver Shift",
    "driverShiftDayWise": "Driver Shift (Day Wise)",
    "driverVerificationAlcohol": "Driver Verification (Alcohol)",
    "driverVerificationDrug": "Driver Verification (Drug)",
    "driverdisplayname": "driver.displayName",
    "driversDrugTest": "Driver's Drug Test",
    "drivingRecordMeetsRequiremen": "Driving Record (Meets Requirement)",
    "drop": "Drop",
    "dropoffAddress": "Dropoff Address",
    "dropoffAddressIsRequired": "Dropoff Address is required",
    "dropoffEarly": "Dropoff Early:",
    "dropoffHeader": "Dropoff",
    "dropoffLate": "Dropoff Late:",
    "dropoffLateReason": "Dropoff Late Reason:",
    "dropoffLateReason2": "Dropoff Late Reason",
    "dropoffWise": "Dropoff Wise",
    "dryRun": "Dry Run",
    "dryRunCode": "Dry Run Code",
    "dryRunCodeIs": "Dry Run Code is Required",
    "dsr": "DSR:",
    "dt": "DT",
    "dt2": "DT:",
    "dueDay": "Due Day *",
    "duplicate": "Duplicate",
    "durationIsRequired": "Duration is required.",
    "dvCompetencyAssessmentIss": "DV Competency Assessment (ISS)",
    "dvRequired": "DV Required",
    "earlyActionActualVsScheduled": "Early Action (Actual start vs Scheduled)",
    "earlyEta": "Early ETA",
    "editNotes": "Edit Notes",
    "editProfile": "Edit profile",
    "editShift": "Edit shift",
    "editTripHeader": "Edit",
    "elderAbuseTraining": "Elder Abuse Training",
    "eligibility": "Eligibility",
    "eligibilityStatusIsRequired": "Eligibility status is required",
    "eligible": "Eligible",
    "email": "Email:",
    "emailAddress": "Email address",
    "emailAddressIsRequired": "Email Address is required",
    "emailConfiguration": "Email Configuration",
    "emailIsNotValid": "Email is not Valid",
    "emailLabel": "Email",
    "emailRequired": "Email is required",
    "emergencyAndEvacuationTraini": "Emergency and Evacuation Training",
    "employeeId": "Employee ID",
    "employeeIdIsRequired": "Employee ID is required",
    "employerNameIsRequired": "Employer name is required",
    "employmentType": "Employment Type",
    "employmentTypeIsRequired": "Employment Type is required",
    "emtDriver": "EMT Driver",
    "emtLicense": "EMT License",
    "emtLicenseImageIs": "EMT License Image is required",
    "endDateLabel": "End Date",
    "endDateRequired": "End Date is required",
    "endOfShift": "End of Shift",
    "endTime": "End Time",
    "endTimeIsRequired": "End Time is required",
    "ended": "(Ended)",
    "endedAt": "Ended At:",
    "englishLanguageLabel": "English",
    "ensureThereAreNo": "⚠️ Ensure there are no spaces around the colon. Minimum 3 characters required to trigger search.",
    "enterTitle": "Enter Title",
    "enterYourEmail": "Enter your email",
    "enterYourEmailAnd": "Enter your email and select role to receive reset link",
    "enterYourNewPassword": "Enter your new password below",
    "equipmentsAreRequired": "Equipments are required",
    "esf": "ESF:",
    "estimatedFareLabel": "Estimated Fare",
    "estimatedFares": "Estimated Fares",
    "estimatedPickupTimeLabel": "Est. PU:",
    "every": "Every",
    "exiting": "Exiting",
    "expandOnHover": "Expand on Hover",
    "expectedAppointmentTimeLabel": "Expected Appointment Time",
    "expectedAppointmentTimeMinError": "Expected Appointment Time cannot be earlier than the Pickup (Date & Time).",
    "expectedAppointmentTimeRequired": "Expected Appointment Time is required",
    "expenses": "Expenses",
    "expirationDate": "Expiration date",
    "expirationDateIsRequired": "Expiration Date is required",
    "expired": "Expired",
    "expiredTrips": "Expired Trips",
    "expiredTripsRoutes": "Expired Trips Routes",
    "expiryDate": "Expiry Date",
    "expiryDateIsRequired": "Expiry Date is required",
    "exportCsv": "Export CSV",
    "extensiondispatcherNumber": "Extension/Dispatcher Number",
    "extensiondispatcherNumberIsR": "Extension/Dispatcher Number is required",
    "exteriorInformation": "Exterior Information",
    "fare": "Fare",
    "fareInformation": "Fare Information",
    "faxNumber": "Fax Number",
    "feedback": "Feedback",
    "feet": "(feet)",
    "fetch": "Fetch",
    "fetchEta": "Fetch ETA",
    "fetchTime": "Fetch Time",
    "file": "(File)",
    "fileIsRequired": "file is required",
    "fileName": "File Name",
    "filter": "Filter",
    "fingerPrintLiveScan": "Finger Print Live Scan",
    "finished": "Finished",
    "finishedAndCancelled": "Finished And Cancelled",
    "finishedAt": "Finished At:",
    "finishedCompleted": "Finished / Completed",
    "finishedTimeIsRequired": "Finished Time is required",
    "finishedTrips": "Finished Trips",
    "firstName": "First Name",
    "firstNameIsRequired": "First Name is required",
    "firstNameMustBe": "First Name must be at least 3 characters.",
    "fleet": "Fleet",
    "fleetInformation": "Fleet Information",
    "fleetIsRequired": "Fleet is required",
    "floorLabel": "Floor",
    "floorRequired": "Floor is required",
    "florida": "Florida",
    "flu": "Flu",
    "fluVaccine": "Flu Vaccine",
    "fluVaccineDeclined": "Flu Vaccine Declined",
    "focalPerson": "Focal Person",
    "focalPersonInformation": "Focal Person Information",
    "for": "For",
    "force": "Force",
    "forcedAcceptTrips": "Forced Accept Trips",
    "forgotPassword": "Forgot Password",
    "forgotPassword2": "Forgot Password?",
    "form837": "Form 837",
    "form837V2": "Form 837 v2",
    "freeQuota": "Free Quota",
    "from": "From",
    "fromIsRequired": "From is required",
    "fsIsRequired": "FS is required",
    "fuelType": "Fuel Type",
    "fuelTypeIsRequired": "Fuel Type is required",
    "fullTime": "Full Time",
    "fundingSourceAndValidity": "Funding Source and Validity Range are required",
    "fundingSourceLabel": "Funding Source",
    "noViolation": "No Violation",
    "fundingSourceRequired": "Funding Source is required",
    "fundingSources": "Funding Source(s)",
    "fundingSourcesAreRequired": "Funding Sources are required",
    "garage": "Garage",
    "garageAddress": "Garage Address",
    "garageAddressIsRequired": "Garage Address is required",
    "gasCardNumber": "Gas Card Number",
    "gasCardNumberIs": "Gas Card Number is required",
    "genderFemale": "Female",
    "genderLabel": "Gender",
    "genderMale": "Male",
    "genderOther": "Other",
    "genderRequired": "Gender is required",
    "general": "General",
    "georgia": "Georgia",
    "gisMiles": "GIS Miles",
    "goBackHome": "Go back home",
    "googleMiles": "Google Miles",
    "groundClearanceIsRequired": "Ground Clearance is required",
    "groupByName": "Group By Name",
    "groupImageIsRequired": "Group Image is required",
    "groupName": "Group Name",
    "groupNameIsRequired": "Group Name is required",
    "groups": "Groups",
    "gurneyTraining": "Gurney Training",
    "handsFreeTraining": "Hands Free Training",
    "haversineMiles": "Haversine Miles",
    "height": "Height",
    "heightIsRequired": "Height is required",
    "hepatitis": "Hepatitis",
    "hhmm": "(HH:mm)",
    "hhmm2": "HHmm",
    "hhmm3": "HH:mm",
    "hideOneHourException": "Hide One Hour Exception",
    "hideThirdPartyDrivers": "Hide Third Party Drivers",
    "hideUnassignedTrips": "Hide Unassigned Trips",
    "hipaaPhiTrainingValid": "HIPAA / PHI Training (Valid forever)",
    "history": "History",
    "holidayName": "Holiday Name",
    "holidayNameIsRequired": "Holiday Name  is required",
    "hoodInformation": "Hood Information",
    "hospitalized": "Hospitalized",
    "host": "host",
    "howToUseThe": "🔍 How to Use the Search",
    "iaal": "IAAL",
    "ifYouAlterThe": "If you alter the information of a trip such that it does not match the details of actual trip which took place, you are filing a false statement and committing a crime. Anyone filing a false statement will be prosecuted to the fullest extent of the law.",
    "image": "image",
    "imageIsRequired": "Image is required",
    "img-corporate": "img-corporate",
    "importFile": "Import File",
    "importingTripsFromBrokers": "Importing trips from brokers",
    "inActiveReason": "In Active Reason",
    "inActiveReasonIs": "In Active Reason is required",
    "inMinutes": "(in minutes)",
    "inProgress": "In Progress",
    "inProgressTrips": "In Progress Trips",
    "inProgressRoutes": "In Progress Routes",
    "inReview": "In Review",
    "inVehicle": "In Vehicle",
    "inactive": "Inactive",
    "incentive": "Incentive",
    "incentiveIsRequired": "Incentive is required",
    "indiana": "Indiana",
    "ineligible": "Ineligible",
    "info": "Info",
    "informDriver": "Inform Driver",
    "information": "Information",
    "inspectionPassOrFail": "Inspection Pass or Fail is required",
    "interiorInformation": "Interior Information",
    "invalidEmailFormat": "Invalid email format",
    "invalidTrip": "Invalid Trip",
    "invoice": "Invoice",
    "invoices": "Invoices",
    "ipaLabel": "IPA / FECA Number",
    "ipaRequired": "IPA / FECA Number is required",
    "ipcr": "IPCR",
    "isAcknowledgementOnFile": "Is acknowledgement on file?",
    "isCertificateOnFile": "Is certificate on file?",
    "isWave": "Is wave",
    "issueDate": "Issue date",
    "issueDateIsRequired": "Issue Date is required",
    "itineries": "Itineries",
    "kpisdriverdisplayname": "kpis.driver.displayName",
    "language": "Language",
    "lastInspectionDateIs": "Last inspection date is required",
    "lastName": "Last Name",
    "lastNameIsRequired": "Last Name is required",
    "lastNameMustBe": "Last Name must be at least 3 characters.",
    "lateCushion": "Late Cushion",
    "lateCushionIsRequired": "Late Cushion is Required",
    "lateEta": "Late ETA",
    "lbs": "(lbs)",
    "legCancellationAlert": "Leg Cancellation Alert",
    "legLabel": "Leg-",
    "legalInformation": "Legal Information",
    "legalName": "Legal Name",
    "legalNameIsRequired": "Legal Name is required",
    "legalNameMustBe": "Legal Name must be at least 3 characters.",
    "lengthIsRequired": "Length is required",
    "lengthMustBe3": "Length must be 3",
    "levelOfServiceImage": "level of service image",
    "levelOfServiceLabel": "Level of Service",
    "levelOfServiceRequired": "Level of Service is required",
    "levelofservice-image": "levelOfService-image",
    "licenseInformation": "License Information",
    "licenseNumber": "License Number",
    "licenseNumberIsRequired": "License Number is required",
    "licensePlate": "License Plate",
    "licensePlateInformation": "License Plate Information",
    "licensePlateIsRequired": "License plate is required",
    "lightsInformation": "Lights Information",
    "limitation": "Limitation",
    "limitations": "Limitations",
    "line": "Line",
    "list": "List",
    "listView": "List View",
    "livescanDojFbi": "LIVESCAN (DOJ +FBI)",
    "livescanDojOnly": "LIVESCAN (DOJ Only)",
    "load": "Load",
    "loadTimeIsRequired": "Load Time is required",
    "loadedMilesRateIs": "Loaded Miles Rate is required",
    "loadedTime": "Loaded Time",
    "loadedTimeToDropoff": "Loaded Time (to Dropoff)",
    "loginInformation": "LOGIN INFORMATION",
    "logisticareTemplate": "LogistiCare Template",
    "logo": "logo",
    "logout": "Logout",
    "logs": "Logs",
    "los": "LOS:",
    "losAndSpaceType": "Los and Space Type is required",
    "lt": "LT",
    "lt2": "LT:",
    "lunch": "Lunch",
    "maintenanceInformation": "Maintenance Information",
    "maintenances": "Maintenances",
    "makeItLive": "Make It Live",
    "makeModel": "Make & Model",
    "makeModelIsRequired": "Make & Model is required",
    "mandatoryForCms1500": "(Mandatory for CMS 1500 Form)",
    "mandatoryForMedicaidAnd": "(Mandatory for Medicaid and CMS 1500 Forms)",
    "mandatoryForMedicaidAuth": "(Mandatory for Medicaid Auth Form)",
    "manifest": "Manifest",
    "manifestLegend": "Manifest Legend",
    "manual": "Manual",
    "manualGenerate": "Manual Generate",
    "manualTrip": "Manual Trip",
    "mapperIsRequired": "Mapper is required",
    "markComplete": "Mark Complete",
    "markMemberReady": "Mark member ready",
    "markedReady": "Marked Ready",
    "markedReadyRoutes": "Marked Ready Routes",
    "markedReadyTrips": "Marked Ready Trips",
    "marketplace": "Marketplace",
    "maxDistance": "Max Distance:",
    "maxOnboardTime": "Max Onboard Time:",
    "maxTrips": "Max Trips:",
    "meal": "Meal",
    "mealBreak": "Meal Break",
    "mechanicverificationsignatur": "mechanicVerification.signature",
    "medex": "MEDEX",
    "medical": "Medical",
    "medicalIdIsRequired": "Medical Id is required",
    "medicalLogo": "Medical Logo",
    "medicalTrip": "Medical Trip",
    "member-image": "member-image",
    "memberLabel": "Member",
    "memberLoading": "Member Loading",
    "memberName": "Member Name",
    "memberNotVisible": "Member not visible",
    "memberOnboard": "Member Onboard",
    "memberOnboardAt": "Member Onboard At:",
    "memberRequired": "Member is required",
    "memberRoleIsRequired": "Member Role is required",
    "memberStatus": "Member Status",
    "memberType": "Member Type",
    "memberTypeIsRequired": "Member Type is required",
    "memberdisplayname": "member.displayName",
    "membersPhoneNumber": "Member's Phone Number",
    "merge": "Merge",
    "messageAlerts": "Message Alerts",
    "messages": "Messages",
    "methadone": "Methadone",
    "method": "Method",
    "methodIsRequired": "Method is required",
    "mfa": "(MFA)",
    "mfb": "Mfb",
    "mi": "mi",
    "mid": "Mid",
    "middleName": "Middle Name",
    "middleNameIsRequired": "Middle Name is required",
    "mile": "Mile",
    "miles": "miles",
    "milesForBucksDriver": "Miles for Bucks Driver",
    "milesForBucksPanel": "Miles for Bucks Panel",
    "milesLabel": "Miles",
    "milesRequired": "Miles is required",
    "minimum3CharactersRequired": "Minimum 3 characters required",
    "minimum5CharactersRequired": "Minimum 5 characters required",
    "mins": "Mins",
    "minutes": "minutes",
    "minutesIsRequired": "Minutes is required",
    "mm": "(mm)",
    "mmddyyyy": "MM/DD/YYYY",
    "mobileNumberLabel": "Mobile Number",
    "mobileNumberRequired": "Mobile Number is required",
    "model": "Model",
    "modelIsRequired": "Model is required",
    "modifierLabel": "Modifier",
    "modifierRequired": "Modifier is required",
    "moicu": "MoICU",
    "moreFeaturesComingSoon": "📝 More Features Coming Soon",
    "moreLabel": "more...",
    "na": "N/A",
    "name": "Name",
    "nameIsRequired": "Name is required",
    "nemt": "NEMT",
    "nemtStatistics": "NEMT Statistics",
    "newExpense": "New Expense",
    "newInspection": "New Inspection",
    "newPassword": "New Password",
    "newPasswordIsRequired": "New Password is required",
    "no": "No",
    "noAgentTripsTo": "No agent trips to show",
    "noAnswer": "No Answer",
    "noCompanyDetailsTo": "No Company Details To Show",
    "noCtcTripTo": "No CTC trip to show",
    "noDataToShow": "No Data to show",
    "noDetailsToShow": "No Details To Show",
    "noDirtRoadTrips": "No Dirt Road Trips To Show",
    "noDriverDetailsTo": "No Driver Details To Show",
    "noEarning": "No Earning",
    "noEarningsToShow": "No Earnings To Show",
    "noMessageToShow": "No message to show",
    "noNotificationsToShow": "No notifications to show",
    "noOfEscortsLabel": "No. Of Escorts",
    "noOfEscortsRequired": "No. Of Escorts is required",
    "noOfRoutes": "No. of Routes",
    "noOfRoutesAre": "No. of routes are Required",
    "noOfSeats": "No. of Seats",
    "noOfSeatsAre": "No. of Seats are Required",
    "noParsedFileFound": "No Parsed file found",
    "noRecords": "No Records",
    "noShowCharges": "No Show Charges",
    "noShowChargesIs": "No Show Charges is required",
    "noStatisticsToShow": "No Statistics To Show",
    "noTripLogsTo": "No Trip Logs To Show",
    "noTripsAssign": "No Trips Assign",
    "noTripsToShow": "No Trips To Show",
    "noUnassignedTrips": "No unassigned trips",
    "non-transportVehicle": "Non-Transport Vehicle",
    "none": "None",
    "notAvailable": "Not Available",
    "notEligible": "Not Eligible",
    "note": "Note",
    "notes": "Notes",
    "notesAreRequired": "Notes are required",
    "notificationMethod": "Notification method",
    "notifications": "Notifications",
    "odometer": "Odometer",
    "odometerBegin": "Odometer Begin",
    "odometerBeginIsRequired": "Odometer Begin is required",
    "odometerBeginReadingIs": "Odometer Begin Reading is required",
    "odometerEndIsRequired": "Odometer End is required",
    "odometerRequired": "Odometer Required",
    "odometerStart": "Odometer Start",
    "odometerStartIsRequired": "Odometer Start is required",
    "odometerStop": "Odometer Stop",
    "odometerStopIsRequired": "Odometer Stop is required",
    "of": "of",
    "offeredAccepted": "Offered / Accepted",
    "offeredTrips": "Offered Trips",
    "offline": "Offline",
    "oigScreening": "OIG Screening",
    "onScene": "On Scene:",
    "onScene2": "On Scene",
    "onSceneReport": "On Scene Report",
    "onWay": "On Way",
    "onWayAt": "On Way At:",
    "onboard": "Onboard",
    "oneHourException": "1 Hour Exception",
    "onq": "ONQ",
    "onscene": "OnScene",
    "onsceneTimeIsRequired": "Onscene Time is required",
    "onway": "Onway",
    "open": "Open",
    "openMainMenu": "Open main menu",
    "openUserMenu": "Open user menu",
    "opener": "Opener",
    "operations": "Operations",
    "operationsManager": "Operations Manager",
    "operationsManagerIsRequired": "Operations Manager is required",
    "optIn": "OPT In",
    "orDragAndDrop": "or drag and drop",
    "ordAct": "Ord/Act",
    "order": "Order",
    "orderIsRequired": "Order is Required",
    "organizationId": "Organization ID",
    "organizationIdIsRequired": "Organization ID is Required",
    "otherInformation": "Other Information",
    "otherLegsHeader": "Other Legs",
    "others": "Others",
    "otp": "OTP",
    "outsideShift": "Outside Shift",
    "outstandingTrips": "Outstanding Trips",
    "ownerDetails": "Owner Details",
    "pageNotFound": "Page not found",
    "paid": "Paid",
    "panel": "Panel",
    "parseTrips": "Parse Trips",
    "partTime": "Part Time",
    "partner": "Partner",
    "passenger": "Passenger",
    "passengerAssistanceAndCultur": "Passenger Assistance and Cultural Training (EXP)",
    "passengerInformation": "Passenger Information",
    "password": "Password",
    "passwordInformation": "Password Information",
    "passwordIsRequired": "Password is Required",
    "passwordMustBeAtleast": "Password must be atleast 6 character",
    "passwordMustBeAtleast2": "Password must be atleast 6 characters",
    "passwordMustBeMaximum": "Password must be maximum of 16 character",
    "passwordMustBeMaximum2": "Password must be maximum of 16 characters",
    "patient": "Patient",
    "paymentConfirmed": "Payment Confirmed",
    "paymentUnconfirmed": "Payment UnConfirmed",
    "payorLabel": "Payor",
    "pending": "Pending",
    "pendingFee": "Pending Fee *",
    "perMile": "Per Mile",
    "perMileCode": "Per Mile Code",
    "perMileCodeIs": "Per Mile Code is Required",
    "perMileIsRequired": "Per Mile is Required",
    "perMinIsRequired": "Per min is required",
    "perMinute": "Per Minute",
    "period": "Period",
    "permissions": "Permissions",
    "person": "Person",
    "phoneNumberLabel": "Phone Number",
    "phoneNumberRequired": "Phone Number is required",
    "pickupAddress": "Pickup Address",
    "pickupAddressIsRequired": "Pickup  Address is required",
    "pickupEarly": "Pickup Early:",
    "pickupHeader": "Pickup",
    "pickupLate": "Pickup Late:",
    "pickupLateReason": "Pickup Late Reason",
    "pickupLateReasons": "Pickup Late Reasons:",
    "pickupTme": "Pickup Tme",
    "pickupWise": "Pickup Wise",
    "placeNameLabel": "Home/Facility Name",
    "placeNameRequired": "Home/Facility Name is required",
    "planner": "Planner",
    "platform": "Platform",
    "platformIsRequired": "Platform is required",
    "platformportal": "Platform/Portal",
    "platformportalIsRequired": "Platform/Portal is required",
    "pleaseChooseAnyAbove": "Please choose any above reason",
    "pleaseEnterDispatcherNotes": "Please enter dispatcher notes",
    "pleaseEnterForDriver": "Please enter For Driver notes",
    "pleaseEnterTheClient": "Please enter the Client Name",
    "pleaseEnterTheDate": "Please enter the Date of the Driver's motor vehicle record check",
    "pleaseEnterTheDescription": "Please enter the description",
    "pleaseEnterTheNote": "Please enter the Note",
    "pleaseEnterTheNotes": "Please enter the Notes",
    "pleaseEnterThePrivate": "Please enter the Private Note",
    "pleaseEnterTheTime": "Please enter the time zone",
    "pleaseNoteByUsing": "Please note, by using this feature you must omit any trips that have not been performed on ground so no information is fabricated on the system.",
    "pleaseSelectAtLeast": "Please select at least one driver.",
    "pleaseSelectCompanyTo": "Please select company to display the record",
    "pleaseSelectPrimaryMember": "Please select primary member",
    "pleaseSelectTimeIn": "Please select time in at",
    "pleaseTakeNoticeFiling": "PLEASE TAKE NOTICE: FILING FALSE STATEMENTS IS A CRIME",
    "pngJpgGifUp": "PNG, JPG, GIF up to 10MB",
    "policeClearance": "Police Clearance",
    "port": "port",
    "portIsRequired": "Port is Required",
    "position": "Position",
    "positionIsRequired": "Position is required",
    "possibilityButton": "Possibility",
    "primary": "Primary",
    "primaryDiagnoseLabel": "Primary Diagnose",
    "primaryDiagnoseRequired": "Primary Diagnose is required",
    "priority": "Priority",
    "priorityIsRequired": "Priority is Required",
    "privateLabel": "(Private)",
    "privateNote": "Private Note",
    "proceed": "Proceed",
    "proficiency": "Proficiency",
    "proficiencyIsRequired": "Proficiency is required",
    "profile": "Profile",
    "profileImage": "Profile Image",
    "profileImageIsRequired": "Profile Image is required",
    "profileInformation": "Profile Information",
    "profileOverview": "Profile Overview",
    "profileimage": "profile_image",
    "protips": "Protips",
    "proposedReadyTime": "Proposed Ready Time",
    "pu": "PU",
    "puModifier": "PU Modifier",
    "puModifierIsRequired": "PU Modifier is required",
    "pua": "PUA",
    "publicLabel": "(Public)",
    "pull-Out": "PULL - OUT",
    "pullEnd": "PULL / END",
    "punjabiLanguageLabel": "Punjabi",
    "put": "PUT",
    "quantityLabel": "Quantity",
    "quantityRequired": "Quantity is required",
    "quarterdisplayname": "quarter.displayName",
    "quickFilter": "Quick-Filter",
    "quickSearch": "Quick search",
    "quickSearchGuide": "🔍 Quick Search Guide",
    "radiusIsRequired": "Radius is required",
    "rates": "Rates",
    "rawReport": "Raw Report",
    "re-assign": "Re-assign",
    "readyNotes": "Ready Notes",
    "reason": "Reason",
    "reasonIsRequired": "Reason is Required",
    "recurringDays": "Recurring Days",
    "recurringStatusRequired": "Recurring Status is required",
    "refS": "Ref #s",
    "reference": "Reference",
    "reg": "Reg:",
    "regular": "Regular",
    "reject": "Reject",
    "rejected": "Rejected",
    "rejectedTrips": "Rejected Trips",
    "relation": "Relation",
    "relationIsRequired": "Relation is required",
    "removeButton": "Remove",
    "reply": "Reply",
    "reports": "Reports",
    "representativesignature": "representative.signature",
    "requiredOdometers": "Required Odometers",
    "rescheduleTrip": "Reschedule Trip",
    "resendCode": "Resend Code?",
    "reservationNo": "Reservation No:",
    "reset": "Reset",
    "resetPassword": "Reset Password",
    "responseNightCode": "Response Night Code",
    "responseNightCodeIs": "Response Night Code is Required",
    "rest": "Rest",
    "restBreak": "Rest Break",
    "return": "Return",
    "revenue": "Revenue",
    "reviewUrl": "Review URL",
    "rfLfRrLr": "(RF LF RR LR)",
    "rigNo": "Rig No.",
    "rigNoIsRequired": "Rig No is required",
    "ripplingId": "Rippling Id",
    "ripplingIdIsRequired": "Rippling Id is required",
    "ripplingSync": "Rippling Sync",
    "rode": "Rode",
    "roleIsRequired": "Role is required",
    "roleType": "Role Type",
    "roleTypeIsRequired": "Role Type is required",
    "roomLabel": "Room",
    "roomRequired": "Room is required",
    "routeDetails": "Route Details",
    "routeView": "Route View",
    "samScreening": "SAM Screening",
    "save": "Save",
    "saveForAll": "Save For All",
    "saveTemplate": "Save Template",
    "scheduleShells": "Schedule Shell(s)",
    "scheduleShellsIsRequired": "Schedule Shell(s) is required",
    "scheduleTime": "Schedule Time",
    "scheduleTimeIsRequired": "Schedule Time is required",
    "scheduledTrips": "Scheduled Trips",
    "score": "Score",
    "scoreDetails": "Score Details",
    "search": "Search",
    "search2": "Search...",
    "searchCompany": "Search Company",
    "searchDriver": "Search Driver",
    "searchGroup": "Search Group",
    "searchMessages": "Search Messages",
    "searchVehicle": "Search Vehicle",
    "seconds": "(seconds)",
    "secureComplianceTrainingAckn": "Secure Compliance Training Acknowledgement",
    "secureType": "Secure Type",
    "seeAll": "See All",
    "seenBy": "Seen by",
    "selectAddonItemPlaceholder": "-- Select Item --",
    "selectAll": "Select All",
    "selectAppointmentDirectionPlaceholder": "-- Select Appointment Direction --",
    "selectAppointmentTypePlaceholder": "-- Select Appointment Type --",
    "selectAssistsPlaceholder": "-- Select Assists --",
    "selectBreak": "Select Break",
    "selectCorporate": "Select Corporate",
    "selectDate": "Select Date",
    "selectDateRange": "Select Date Range",
    "selectDos": "Select DOS",
    "selectDriver": "Select Driver",
    "selectDriverPlaceholder": "-- Select Driver --",
    "selectFundingSource": "Select Funding Source",
    "selectFundingSourcePlaceholder": "-- Select Funding Source --",
    "selectGenderPlaceholder": "-- Select Gender --",
    "selectLevelOfService": "Select Level of Service",
    "selectLevelOfServicePlaceholder": "-- Select Level of Service --",
    "selectMember": "Select Member",
    "selectMemberPlaceholder": "-- Select Member --",
    "selectModifierPlaceholder": "-- Select Modifier --",
    "selectNoOfEscortsPlaceholder": "-- Select No. Of Escort --",
    "selectPayorPlaceholder": "-- Select Payor --",
    "selectPrimaryDiagnosePlaceholder": "-- Select Primary Diagnose --",
    "selectServiceArea": "Select Service Area",
    "selectServiceAreaPlaceholder": "-- Select Service Area --",
    "selectSpaceType": "Select Space type",
    "selectSpaceTypePlaceholder": "-- Select Space Type --",
    "selectStatus": "Select Status",
    "selectTime": "Select Time",
    "selectTimezone": "Select timezone",
    "selectType": "Select type",
    "selectedDriverIsRequired": "Selected Driver is required",
    "selectedServiceAreaIs": "Selected Service Area is required",
    "selectedTrip": "Selected Trip",
    "send": "Send",
    "sendCode": "Send Code",
    "sendEmail": "Send Email",
    "sendOnBreak": "Send on Break",
    "sentYouAnInvite": "Sent you an invite to connect.",
    "serviceAreaLabel": "Service Area",
    "serviceAreaRequired": "Service Area is required",
    "serviceAreas": "Service Area(s)",
    "serviceAreasIsRequired": "Service Area(s) is required",
    "serviceNameIsRequired": "Service name is required",
    "serviceRepresentative": "SERVICE REPRESENTATIVE",
    "services": "Services",
    "setBsr": "Set BSR",
    "setTags": "Set Tags",
    "setiD": "Seti D:",
    "settings": "Settings",
    "sexOffenderBackgroundCheck": "Sex Offender Background Check",
    "sexualHarassmentTraining": "Sexual Harassment Training",
    "shift": "Shift:",
    "shift-End": "SHIFT - END",
    "shiftAlign": "Shift Align",
    "shiftAlignIsRequired": "Shift Align is required",
    "shiftDayWise": "Shift (Day Wise)",
    "shiftEnd": "Shift End",
    "shiftEndIsRequired": "Shift End is required",
    "shiftMarker": "Shift Marker",
    "shiftOverride": "Shift Override",
    "shiftOverrideNotAvailable": "Shift Override (Not Available)",
    "shiftStart": "Shift Start",
    "shiftStartIsRequired": "Shift Start is required",
    "shifts": "Shifts",
    "showBreak": "Show Break",
    "showGoogleMiles": "Show Google Miles",
    "showRoute": "Show Route",
    "showUnassignedTrips": "Show Unassigned Trips",
    "signIn": "Sign in",
    "signInToYour": "Sign in to your account",
    "signature": "Signature",
    "signatureIsRequired": "Signature is required",
    "single": "Single",
    "skipSignature": "Skip Signature",
    "smokeFreeVehiclesDriver": "Smoke Free Vehicles (Driver Understanding)",
    "sms": "SMS",
    "sms/dashboard": "SMS/Dashboard",
    "smsRequired": "SMS Required",
    "sorryWeCouldntFind": "Sorry, we couldn’t find the page you’re looking for.",
    "sort": "Sort",
    "spaceTypeLabel": "Space Type",
    "spaceTypeRequired": "Space Type is required",
    "spaceTypefileIsRequired": "Space Type(File) is required",
    "spaceTypesIsRequired": "Space Type(s) is required",
    "spacetypeImage": "SpaceType image",
    "spacetypeIsRequired": "SpaceType is required",
    "spacetypes": "Spacetype(s)",
    "spanishLanguageLabel": "Spanish",
    "specialFare": "Special Fare",
    "specialRequests": "Special Requests",
    "squareImageIsRecommended": "*Square Image is recommended",
    "ssl": "ssl",
    "staff": "(Staff)",
    "stagingTrips": "Staging Trips",
    "stairsSteps": "Stairs step/s",
    "stairsStepsIsRequired": "Stairs step/s is required",
    "standingOrderHeader": "Standing Order",
    "startDate": "Start Date",
    "startDateIsRequired": "Start date is required",
    "startTime": "Start Time",
    "startTimeIsRequired": "Start time is required",
    "started": "Started",
    "startedAt": "Started At:",
    "startedTimeIsRequired": "Started Time is required",
    "statReport": "Stat Report",
    "stateCode": "State Code",
    "stateCodeIsRequired": "State Code is required",
    "stateIsRequired": "State is required",
    "statistics": "Statistics",
    "statusActive": "Active",
    "statusInactive": "In Active",
    "statusIsRequired": "Status is required",
    "statusLabel": "Status",
    "statuses": "Statuses",
    "statuss": "Status(s)",
    "stop": "Stop",
    "stopTimeIsRequired": "Stop time is required",
    "storageInformation": "Storage Information",
    "submit": "Submit",
    "suggestTime": "Suggest Time",
    "suggestedTime": "Suggested Time",
    "support": "Support",
    "svc": "Svc",
    "sweep": "Sweep",
    "sweepFile": "Sweep File",
    "table": "Table",
    "table-user": "table-user",
    "takeSignature": "Take Signature",
    "taxInformation": "Tax Information",
    "taxonomyCode": "Taxonomy Code",
    "tbTest": "TB Test",
    "template": "Template",
    "templateIsRequired": "Template is required",
    "textAssistanceRequiredFor": "Text Assistance Required for the Member.",
    "textLiveLinkTo": "Text Live Link to the Member",
    "thirdParty": "Third Party",
    "thisOperationWillComplete": "This operation will complete the information required to generate insurance claim files like trip logs, TRF forms etc.",
    "threshold": "Threshold",
    "thresholdIsRequired": "Threshold is required",
    "timeCalibration": "Time Calibration",
    "timeFormat": "Time Format",
    "timeFormatIsRequired": "Time Format is required",
    "timeIn": "Time In",
    "timeInAt": "Time In At",
    "timeInIsRequired": "Time In is required",
    "timeLabel": "Time",
    "timeOut": "Time Out",
    "timeOutIsRequired": "Time Out is required",
    "timeRequired": "Time is required",
    "timeZone": "Time Zone",
    "timeZoneIsRequired": "Time zone is required",
    "timein": "Timein",
    "timeline": "Timeline",
    "timelines": "Timelines",
    "times": "&times;",
    "tipStatusIsRequired": "Tip Status is required",
    "tipTitleIsRequired": "Tip Title is required",
    "tiresInformation": "Tires Information",
    "title": "Title",
    "titleIsRequired": "Title is required",
    "tls": "tls",
    "to": "to",
    "toIsRequired": "To is required",
    "today": "Today",
    "toll-freeNumber": "Toll-Free Number",
    "toll-freeNumberIsRequired": "Toll-Free Number is Required",
    "totalFare": "Total Fare",
    "totalFareIsRequired": "Total Fare is required",
    "tp": "(TP)",
    "traffic": "Traffic",
    "travelAndSequence": "Travel & Sequence",
    "trial": "Trial",
    "trialEnd": "Trial End",
    "tripAssistance": "Trip Assistance",
    "tripId": "Trip ID",
    "tripIdLabel": "Trip ID",
    "tripIdRequired": "Trip ID is required",
    "tripInformation": "Trip Information",
    "tripLogs": "Trip Logs",
    "tripQuota": "Trip Quota",
    "tripQuotaIsRequired": "Trip Quota is required",
    "tripReport": "Trip Report",
    "tripRoute": "Trip Route",
    "tripS": "trip(s)",
    "tripSequenceLate": "Trip Sequence (Late)",
    "tripSequenceOnTime": "Trip Sequence (On-Time)",
    "tripStatus": "Trip Status",
    "tripWise": "Trip Wise",
    "trips": "Trips",
    "tripsAdjustmentImportant": "Trips adjustment(Important before banking)",
    "tripsFile": "Trips File",
    "tripsFileIsRequired": "Trips File is required",
    "tripsItinerary": "Trips Itinerary",
    "tripsMapDashboard": "Trips Map Dashboard",
    "type": "Type",
    "typeAMessage": "Type a message .....",
    "un-selectAll": "Un-Select All",
    "unassign": "Unassign",
    "unassigned": "Unassigned",
    "unassignedCancelled": "Unassigned Cancelled",
    "unassignedTrips": "Unassigned trips",
    "unconfirm": "Unconfirm",
    "undo": "Undo",
    "unknown": "Unknown",
    "unloadTimeIsRequired": "Unload Time is required",
    "unscheduled": "[Unscheduled]",
    "upBaseAddress": "Up Base Address",
    "updateAssists": "Update Assists",
    "updateButton": "Update",
    "updateStatus": "Update Status",
    "uploadAFile": "Upload a file",
    "uploadAnImage": "Upload an image",
    "uploadJpegJpgOr": "Upload .jpeg, .jpg or .png file",
    "uploadTxtFile": "Upload .txt file",
    "uploadXlsxXlsOr": "Upload .xlsx, .xls or .csv file",
    "urduLanguageLabel": "Urdu",
    "url": "URL",
    "useAPermanentAddress": "Use a permanent address where you can receive mail.",
    "useAuthenticSignatures": "Use authentic signatures.",
    "useMemberPermanentAddress": "Use member permanent address where he/she can receive mail.",
    "useSettingAriaLabel": "Use setting",
    "user": "user",
    "user-image": "user-image",
    "user-img": "user-img",
    "userPhoto": "user photo",
    "username": "Username",
    "usernameIsRequired": "Username is Required",
    "users": "Users",
    "usingTheBelowForm": "Using the below form to add new broker Configuration",
    "usingTheBelowForm2": "Using the below form to add new Email Configuration",
    "v1": "V1",
    "v2": "V2",
    "v3": "V3",
    "validityRange": "Validity Range",
    "validityRangeIsRequired": "Validity Range is required",
    "vehicle": "Vehicle",
    "vehicleDecalNumberIs": "Vehicle decal number is required",
    "vehicleGarage": "Vehicle Garage",
    "vehicleIdentificationNumberI": "Vehicle identification number is required",
    "vehicleImageBack": "Vehicle Image Back",
    "vehicleImageFront": "Vehicle Image Front",
    "vehicleImageLeft": "Vehicle Image Left",
    "vehicleImageRight": "Vehicle Image Right",
    "vehicleInspectionInPast": "Vehicle inspection in past 12 months with lookback period.",
    "vehicleMakeIsRequired": "Vehicle make is required",
    "vehicleRecordCheckDot": "Vehicle Record Check (DOT MVR)",
    "vehicleRecordCheckStandard": "Vehicle Record Check (Standard Check)",
    "vehicleServiceNumberIs": "Vehicle service number is required",
    "vehicleTypeIsRequired": "Vehicle Type is required",
    "vehicleWise": "Vehicle Wise",
    "vehiclesFleet": "Vehicles/Fleet",
    "verifyCode": "Verify Code",
    "viewRoute": "View Route",
    "viewTripsOnly": "View Trips Only",
    "vin": "VIN",
    "vinIsRequired": "VIN is required",
    "violationIsRequired": "Violation is required",
    "violationSets": "Violation Sets",
    "vipExpiryDate": "VIP Expiry Date",
    "vipExpiryDateIs": "VIP Expiry Date is required",
    "vipLabel": "VIP",
    "vipMembers": "Vip Members",
    "virginia": "Virginia",
    "visit": "Visit",
    "voicemail": "Voicemail",
    "waitTime": "Wait Time",
    "waitTimeCode": "Wait Time Code",
    "waitTimeCodeIs": "Wait Time Code is Required",
    "waitTimeIsRequired": "Wait Time is required",
    "wandererRisk": "Wanderer Risk",
    "warning": "Warning",
    "weekendNightCode": "Weekend Night Code",
    "weekendNightCodeIs": "Weekend Night Code is Required",
    "weeklyFee": "Weekly Fee",
    "weeklyFeeIsRequired": "Weekly Fee is required",
    "weightLabel": "Weight",
    "weightRequired": "Weight is required",
    "wheelchairRampInformation": "Wheelchair Ramp Information",
    "wheelchairSecurementTraining": "Wheelchair Securement Training (EXP)",
    "widthIsRequired": "Width is required",
    "willCall": "WillCall",
    "willCall2359": "Will Call (23:59)",
    "willCallActivated": "Will Call Activated",
    "willCallBracket": "[Will Call]",
    "willCallLabel": "Will Call",
    "willCallTrip": "Will Call Trip",
    "wmrNumber": "WMR Number",
    "wmrNumberIsRequired": "WMR Number is required",
    "writeYourCommentHere": "Write your comment here...",
    "yamsolLlc": "YAMSOL LLC",
    "year": "Year",
    "yearIsRequired": "Year is required",
    "yes": "Yes",
    "yourCompany": "Your Company",
    "yourLicenseIsGoing": "Your License is going to expire on 22/11/2020. Please renew and update your license at Hoosier Transportation to avoid any inconvenience.",
    "zipCode": "Zip Code",
    "zipCodeIsRequired": "Zip Code is required",
    "zipIsRequired": "Zip is required",
    "zoneForIsRequired": "Zone For is required",
    "zoneName": "Zone name",
    "zones": "Zones",
    "zoom": "Zoom",
    "id": "ID",
    "escort": "Escort",
    "spRate": "SP. Rate",
    "estFare": "EST. Fare",
    "createdTime": "Created Time",
    "authNumber": "Authorization Number",
    "appointmentTypes": "Appointment Type(s)",
    "dvNotes": "DV Notes",
    "source": "Source",
    "trackingNo": "Tracking No.",
    "roleOrSource": "Role/Source",
    "staffManager": "Staff Manager",
    "mobileNumber": "Mobile Number",
    "updatedAt": "Updated At",
    "createdAt": "Created At",
    "version": "Version",
    "shiftLabel": "Shift",
    "role": "Role",
    "puTime": "PU Time",
    "doTime": "DO Time",
    "puDate": "PU Date",
    "doDate": "DO Date",
    "memberInfo": "Member Info",
    "facilityVeh": "Facility - Veh",
    "noMemberName": "No./ Member Name",
    "dosLabel": "DOS",
    "losLabel": "LOS",
    "pickupTime": "Pickup Time",
    "dropoffTime": "DropOff Time",
    "mileage": "Mileage",
    "reservationNoLabel": "Reservation No.",
    "claimed": "Claimed",
    "onboardStatus": "Onboard Status",
    "insurance": "Insurance",
    "loadTime": "Load Time",
    "unloadTime": "Unload Time",
    "totalTrips": "Total Trips",
    "totalIntake": "Total Intake",
    "serviceCharges": "Service Charges",
    "companyIntake": "Company Intake",
    "remainingAmount": "Remaining Amount",
    "cashPayment": "Cash Payment",
    "creditPayment": "Credit Payment",
    "adjustedAmount": "Adjusted Amount",
    "balance": "Balance",
    "driverEarnings": "Driver Earnings",
    "earnings": "Earnings",
    "cash": "Cash",
    "credit": "Credit",
    "adjusted": "Adjusted",
    "total": "Total",
    "early": "Early",
    "onTime": "On Time",
    "late": "Late",
    "earlyTimeScore": "Early Time Score",
    "onTimeScore": "On Time Score",
    "lateTimeScore": "Late Time Score",
    "actualOnTimeScore": "Actual On Time Score",
    "aptTime": "APT Time",
    "arrivedTime": "Arrived Time",
    "message": "Message",
    "error": "Error",
    "sentDate": "Sent Date",
    "createdDate": "Created Date",
    "memberId": "Member ID",
    "otpStatus": "OTP Status",
    "otpMinutes": "OTP Minutes",
    "oneHourViolation": "1-Hour Violation",
    "filePath": "File Path",
    "mrnLabel": "Member Record Number (MRN)",
    "timestamps": "Time Stamps",
    "trackId": "Track ID",
    "location": "Location",
    "report": "Report",
    "currentMileage": "Current Mileage",
    "inspectedBy": "Inspected By",
    "inspectionCenter": "Inspection Center",
    "result": "Result",
    "passed": "PASSED",
    "failed": "FAILED",
    "dateCorrected": "DATE CORRECTED",
    "frontDriverPassengerCompartment": "FRONT DRIVER / PASSENGER COMPARTMENT",
    "patientCompartment": "PATIENT COMPARTMENT",
    "exteriorVehicle": "EXTERIOR VEHICLE",
    "underHoodCompartment": "UNDER HOOD / COMPARTMENT",
    "fluidsEngine": "FLUIDS / ENGINE",
    "brakeTest": "BRAKE TEST",
    "tiresWheels": "TIRES / WHEELS",
    "brakes": "BRAKES",
    "bodyFrame": "BODY AND FRAME",
    "fuelSystem": "FUEL SYSTEM",
    "exhaustSystem": "EXHAUST SYSTEM",
    "cost": "Cost",
    "category": "Category",
    "shiftTime": "Shift Time",
    "timeInTimeOut": "Time In/Time Out",
    "mealTakenDue": "Meal Taken/Due",
    "restTakenDue": "Rest Taken/Due",
    "workingHours": "Working Hours",
    "breakHours": "Break Hours",
    "loadedMilesRate": "Loaded Miles Rate",
    "deadMilesRate": "Dead Miles Rate",
    "account": "Account",
    "amount": "Amount",
    "approxDo": "~DO",
    "approxPu": "~PU",
    "approxTimeLabel": "Approx Time",
    "approxPuLabel": "Approx PU",
    "approxDoLabel": "Approx DO",
    "currentTrip": "Current Trip",
    "appt": "Appt",
    "arrive": "Arrive",
    "arriveDist": "Arrive Dist",
    "availability": "Availability",
    "breaksAck": "Breaks Ack.",
    "breaksDue": "Breaks Due",
    "breaksTaken": "Breaks Taken",
    "bucket": "Bucket",
    "bumped": "Bumped",
    "cads": "Cads",
    "cancelCharge": "Cancel Charge",
    "cancelledTrips": "Cancelled Trips",
    "changeReason": "Change Reason",
    "claimAmount": "Claim Amount",
    "claimId": "Claim ID",
    "claimPaymentAmount": "Claim Payment Amount",
    "company": "Company",
    "companyIntakeAfterThreshold": "Company Intake After Threshold",
    "completedTrips": "Completed Trips",
    "components": "Components",
    "dateLabel": "Date",
    "day": "Day",
    "declined": "Declined",
    "distDiff": "Dist. Diff.",
    "distance": "Distance",
    "distanceViolet": "Distance Violet.",
    "doAddress": "DO Address",
    "driverIntakeAfterThreshold": "Driver Intake After Threshold",
    "dropoffDiff": "Dropoff Diff.",
    "duration": "Duration",
    "engaged": "Engaged",
    "eta": "ETA",
    "events": "Events",
    "fee": "Fee",
    "flatFee": "Flat Fee",
    "fromTime": "From Time",
    "group": "Group",
    "ignored": "Ignored",
    "lateReason": "Late Reason",
    "loadUnloadTime": "Load/Unload Time",
    "loadedMiles": "Loaded Miles",
    "maxFactor": "Max Factor",
    "minimumFare": "Minimum Fare",
    "netProfit": "Net Profit",
    "newDist": "New Dist.",
    "noOfTrips": "No. of Trips",
    "noShowCharge": "No Show Charge",
    "odometerStartEnd": "Odometer Start-End",
    "onboardViolet": "Onboard Violet.",
    "otherViolet": "Other Violet.",
    "outgoings": "Outgoings",
    "passedFailed": "Passed/Failed",
    "patientName": "Patient Name",
    "pdOrder": "P/D Order",
    "perform": "Perform",
    "performDist": "Perform Dist",
    "phone": "Phone",
    "phoneNo": "Phone No.",
    "pickupDiff": "Pickup Diff.",
    "platformCharges": "Platform Charges:",
    "preDist": "Pre Dist.",
    "price": "Price",
    "puAddress": "PU Address",
    "puDoAddress": "PU - DO Address",
    "remaining": "Remaining",
    "restHours": "Rest Hours",
    "returned": "Returned",
    "rigHash": "Rig#",
    "rigType": "Rig Type",
    "service": "Service",
    "serviceDate": "Service Date",
    "sr": "Sr.",
    "srHash": "Sr#",
    "status": "Status",
    "timeDifference": "Time Difference",
    "timeStamps": "Time Stamps",
    "timeWise": "Time Wise",
    "tip": "Tip",
    "toTime": "To Time",
    "toll": "Toll",
    "totalDeadMileRate": "Total Dead Mile Rate",
    "totalEarning": "Total Earning",
    "totalEarningsColon": "Total Earnings:",
    "totalLoadedMileRate": "Total Loaded Mile Rate",
    "travel": "Travel",
    "tripEarnings": "Trip Earnings",
    "willCallStatus": "Will Call Status",
    "adjustTrips": "Adjust Trips",
    "amendmentReq": "Amendment Req.",
    "assistRequired": "Assist Required?",
    "associateTo": "Associate To",
    "broker": "Broker",
    "calculate": "Calculate",
    "clientIdMemberId": "Client ID / Member ID / MA# / AHCCCS#",
    "displayName": "Display Name",
    "documentExpiry": "Document Expiry",
    "driverGrievanceReport": "Driver Grievance Report",
    "driverSignature": "Driver Signature",
    "generalInformation": "General Information",
    "generateReport": "Generate Report",
    "googleApproximation": "Google Approximation",
    "localApproximation": "Local Approximation",
    "ltiReport": "LTI Report",
    "markConfirmed": "Mark Confirmed",
    "markReady": "Mark Ready",
    "unmarkReady": "Unmark Ready",
    "markUnassigned": "Mark Unassigned",
    "markVoicemail": "Mark Voicemail",
    "milesReport": "Miles Report",
    "modifierTwo": "Modifier Two",
    "otherReason": "Other Reason",
    "partialEdit": "Partial Edit",
    "plusAdd": "+ Add",
    "rating": "Rating",
    "rawTripSummary": "Raw Trip Summary",
    "receiverEmail": "Receiver Email",
    "state": "State",
    "tripsReport": "Trips Report",
    "update": "Update",
    "showing": "Showing",
    "entries": "entries",
    "enterInPercent": "Enter in %",
    "enterInPercentage": "Enter in percentage",
    "selectCorporatePlaceholder": "-- Select Corporate --",
    "grievance": "Grievance",
    "itemLost": "Item Lost",
    "generalShift": "General Shift",
    "addCorporate": "Add Corporate",
    "addCompanies": "Add Companies",
    "Accidental Reports": "Accidental Reports",
    "Addons": "Addons",
    "Announcements": "Announcements",
    "Appointment Types": "Appointment Types",
    "Billing": "Billing",
    "Business Reports": "Business Reports",
    "CheckList": "CheckList",
    "Dashboard": "Dashboard",
    "Availability": "Availability",
    "Dirt Road": "Dirt Road",
    "Driver Alerts": "Driver Alerts",
    "Driver Expense": "Driver Expense",
    "Driver Score": "Driver Score",
    "Driver Wise": "Driver Wise",
    "EDI 835": "EDI 835",
    "Earnings": "Earnings",
    "Extras": "Extras",
    "Fleet": "Fleet",
    "Grievance / Item Lost": "Grievance / Item Lost",
    "Helping Material": "Helping Material",
    "Invoice": "Invoice",
    "Itineries": "Itineries",
    "Maintenance": "Maintenance",
    "Manifest": "Manifest",
    "Manual": "Manual",
    "Modifier Codes": "Modifier Codes",
    "Nemt Pro Tips": "Nemt Pro Tips",
    "Operations": "Operations",
    "Outbounding": "Outbounding",
    "Planner": "Planner",
    "Primary Diagnosis": "Primary Diagnosis",
    "Pro Tips": "Pro Tips",
    "Push to Talk": "Push to Talk",
    "Rates": "Rates",
    "Reports": "Reports",
    "Routing": "Routing",
    "SMS": "SMS",
    "Statistics": "Statistics",
    "Support": "Support",
    "TRFs & Claims": "TRFs & Claims",
    "TRFs Templates": "TRFs Templates",
    "Trips": "Trips",
    "Vehicle Expense": "Vehicle Expense",
    "Vehicle Inspection": "Vehicle Inspection",
    "Zones": "Zones",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "upload": "Upload",
    "export": "Export",
    "import": "Import",
    "refresh": "Refresh",
    "edit": "Edit",
    "view": "View",
    "loading": "Loading...",
    "deselectAll": "Deselect All",
    "more": "more...",
    "clearFilters": "Clear Filters",
    "clearFilter": "Clear Filter",
    "clearAll": "Clear All",
    "applyFilters": "Apply Filters",
    "applyFilter": "Apply Filter",
    "noData": "No data",
    "noResults": "No results",
    "ok": "OK",
    "filters": "Filters",
    "Staging": "Staging",
    "Assigned": "Assigned",

    "memberInfoHeader": "Member Info",
    "serviceInfoHeader": "Service Information",
    "dateTimeHeader": "Date & Time",
    "pickupTimeLabel": "Pickup Time",
    "dropoffTimeLabel": "Dropoff Time",
    "cityLabel": "City",
    "stateLabel": "State",
    "zipCodeLabel": "Zip Code",
    "notesHeader": "Notes",
    "attachmentsHeader": "Attachments",
    "paymentStatus": "Payment Status",
    "assistedBy": "Assisted By:",
    "insuranceId": "Insurance ID",
    "ipaNumber": "IPA Number",
    "passengerName": "Passenger Name",
    "cellPhone": "Cell Phone",
    "dob": "DOB",
    "clientId": "Client ID",
    "forDriver": "For Driver",
    "actualMiles": "Actual Miles",
    "paymentMode": "Payment Mode",
    "deadMinutes": "Dead Minutes",
    "tripMiles": "Trip Miles",
    "tripTime": "Trip Time",
    "totalTripMiles": "Total Trip Miles",
    "totalTripTime": "Total Trip Time",
    "totalTripMilesInclDeadMiles": "Total Trip Miles (incl. Dead Miles)",
    "totalTripTimeInclDeadMinutes": "Total Trip Time (incl. Dead Minutes)",
    "odometerEnd": "Odometer End",
    "enRoute": "En Route",
    "readySince": "Ready Since:",
    "app": "App",
    "availabilityDays": "Availability Days",
    "joiningDate": "Joining Date",
    "sunday": "Sunday",
    "sun": "Sunday",
    "monday": "Monday",
    "mon": "Monday",
    "tuesday": "Tuesday",
    "tue": "Tuesday",
    "wednesday": "Wednesday",
    "wed": "Wednesday",
    "thursday": "Thursday",
    "thu": "Thursday",
    "friday": "Friday",
    "fri": "Friday",
    "saturday": "Saturday",
    "sat": "Saturday",
    "dayMon": "Mon",
    "dayTue": "Tue",
    "dayWed": "Wed",
    "dayThu": "Thu",
    "dayFri": "Fri",
    "daySat": "Sat",
    "daySun": "Sun",
    "addressPicker": "Address Picker",
    "smsConfiguration": "SMS Configuration",
    "confirmationTemplate": "Confirmation Template",
    "default": "Default",
    "boldage": "Boldage"
};
